import { render, staticRenderFns } from "./QuantityPerUserCurrentYearInformation.vue?vue&type=template&id=17159389&"
import script from "./QuantityPerUserCurrentYearInformation.vue?vue&type=script&lang=ts&"
export * from "./QuantityPerUserCurrentYearInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports